import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Article} from '../../models/article';
import {Common} from '../../lib/common';
import {MessagePopoverComponent} from '../message-popover/message-popover.component';
import { Router } from '@angular/router';
import {PopoverController} from '@ionic/angular';
import { ResourcesCssService } from 'src/app/pages/resources/resources-css.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss'],
})
export class ArticleComponent implements OnInit {

  @Input() article: Article
  @Input() icon: string

  articleContent: any
  articleSummary: any

  constructor(
    private popoverCtrl: PopoverController,
    public resourcesCssService: ResourcesCssService,
    private router: Router,
    private sanitizer: DomSanitizer
  ) {

  }

  ngOnInit() {
    this.articleContent = this.sanitizer.bypassSecurityTrustHtml(this.article.content)
    this.articleSummary = this.sanitizer.bypassSecurityTrustHtml(this.article.summary)
  }

  goToArticle() {
    this.router.navigateByUrl('blog/' + this.article.slug)
  }

}
